import type { OnboardingStep, OnboardingStepId, OnboardingStepPath } from './types';

export function onboardingStepPath(id: OnboardingStepId): OnboardingStepPath {
    return `/onboarding/${id}`;
}

const STEP_ORDER: ReadonlyArray<Omit<OnboardingStep, 'path'>> = [
    { id: 'work-categories', labelKey: 'ONBOARDING.STEPS.WORK_CATEGORIES' },
    { id: 'regions', labelKey: 'ONBOARDING.STEPS.REGIONS' },
    { id: 'account', labelKey: 'ONBOARDING.STEPS.ACCOUNT' },
    { id: 'company', labelKey: 'ONBOARDING.STEPS.COMPANY' },
    { id: 'validation', labelKey: 'ONBOARDING.STEPS.VALIDATION' },
    { id: 'registration-channel', labelKey: 'ONBOARDING.STEPS.VALIDATION', progressStepId: 'validation' },
    { id: 'subscription', labelKey: 'ONBOARDING.STEPS.SUBSCRIPTION' },
];

export const ONBOARDING_STEPS: ReadonlyArray<OnboardingStep> = STEP_ORDER.map((step) => ({
    ...step,
    path: onboardingStepPath(step.id),
}));

export const ONBOARDING_PROGRESS_STEPS: ReadonlyArray<OnboardingStep> = ONBOARDING_STEPS.filter(
    (step) => step.progressStepId === undefined,
);

export function getStepIndex(id: OnboardingStepId): number {
    return ONBOARDING_STEPS.findIndex((step) => step.id === id);
}

export function getProgressStepIndex(id: OnboardingStepId): number {
    const progressStepId = ONBOARDING_STEPS.find((step) => step.id === id)?.progressStepId ?? id;
    return ONBOARDING_PROGRESS_STEPS.findIndex((step) => step.id === progressStepId);
}

export function getNextStep(id: OnboardingStepId): OnboardingStep | undefined {
    return ONBOARDING_STEPS[getStepIndex(id) + 1];
}

export function getPreviousStep(id: OnboardingStepId): OnboardingStep | undefined {
    const index = getStepIndex(id);
    return index > 0 ? ONBOARDING_STEPS[index - 1] : undefined;
}

export function isLastStep(id: OnboardingStepId): boolean {
    return getStepIndex(id) === ONBOARDING_STEPS.length - 1;
}

// The backend only ever moves currentStep forward, so it marks the furthest step reached.
export function isStepAheadOf(step: OnboardingStepId, currentStep: OnboardingStepId): boolean {
    return getStepIndex(step) > getStepIndex(currentStep);
}
